export default __webpack_public_path__ + "static/media/peep-62.af01d0f4.svg";